
import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";


// KEEP OLD PROJECT IMAGES (UNCHANGED)
import BlockchainConsulting from "../../images/serviceSection/Web 3.0/Blockchain Consulting.png";
import DeFiSolutions from "../../images/serviceSection/Web 3.0/DeFi Solutions.png";
import DevelopmentServices from "../../images/serviceSection/Web 3.0/Development Services.png";
import NFTMarketing from "../../images/serviceSection/Web 3.0/NFT Marketing.png";
import NFTMarketplaces from "../../images/serviceSection/Web 3.0/NFT Marketplaces.png";
import NFTServices from "../../images/serviceSection/Web 3.0/NFT Services.png";


// SAME ARROW ICON (UNCHANGED)
const ArrowIcon = () => (
  <>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>

    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>
  </>
);

// 🔑 MEGAMENU → PAGE DATA
const megaProjects = [
  {
    title: "Development Services",
    content:
      "End-to-end blockchain and Web3 development services including smart contracts, dApps, enterprise solutions, and scalable decentralized platforms.",
    link: "/development",
    images: [DevelopmentServices, DevelopmentServices, DevelopmentServices, DevelopmentServices],
    reverse: false,
  },
  {
    title: "Blockchain Consulting",
    content:
      "Strategic consulting to help businesses design, validate, and launch blockchain solutions with compliance, scalability, and security in mind.",
    link: "/consulting",
    images: [BlockchainConsulting, BlockchainConsulting, BlockchainConsulting, BlockchainConsulting],
    reverse: true,
  },
  {
    title: "NFT Marketing",
    content:
      "Marketing solutions for NFT projects including community growth, influencer outreach, campaign execution, and launch strategies.",
    link: "/nft-marketing",
    images: [NFTMarketing, NFTMarketing, NFTMarketing, NFTMarketing],
    reverse: false,
  },
  {
    title: "NFT Marketplaces",
    content:
      "Custom NFT marketplace development with minting, auctions, royalties, wallet integration, and secure smart contracts.",
    link: "/nft-marketplace-service",
    images: [NFTMarketplaces, NFTMarketplaces, NFTMarketplaces, NFTMarketplaces],
    reverse: true,
  },
   {
    title: "NFT Services",
    content:
      "Custom NFT development with minting, auctions, royalties, wallet integration, and secure smart contracts.",
    link: "/nft-service",
    images: [NFTServices, NFTServices, NFTServices, NFTServices],
    reverse: true,
  },
  {
    title: "DeFi Solutions",
    content:
      "Decentralized finance platforms including staking, lending, yield farming, and token economics built for performance and trust.",
    link: "/defi",
    images: [DeFiSolutions, DeFiSolutions, DeFiSolutions, DeFiSolutions],
    reverse: false,
  },
];

const ProjectMegaPage: React.FC = () => {
  return (
    <Fragment>
          <div className='service-page inner-page'>
            <div className="body_wrap o-clip">
              <Header />
              <main>
                <PageTitle pageTitle="Web 3.0 " pagesub="Web3.0 Services" />
    <section className="service pos-rel">
      <div className="container mxw-1650">
        <div className="xb-project-wrap xb-project-wrap_2">

          {megaProjects.map((item, index) => (
            <div className="xb-project-item" key={index}>

              {!item.reverse ? (
                <>
                  {/* CONTENT */}
                  <div className="xb-project-content">
                    <div className="xb-item--inner xb-border">
                      <h2 className="xb-item--title">{item.title}</h2>
                      <p className="xb-item--content clr-white">{item.content}</p>

                      <div className="xb-item--btn mt-40">
                        <Link className="thm-btn agency-btn" to={item.link}>
                          <span className="text">Explore</span>
                          <span className="arrow">
                            <span className="arrow-icon"><ArrowIcon /></span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* IMAGES */}
                  <div className="xb-project-img img-hove-effect">
                    <div className="xb-img">
                      {item.images.map((img, i) => (
                        <Link to={item.link} key={i}>
                          <img src={img} alt="service" />
                        </Link>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {/* IMAGES FIRST */}
                  <div className="xb-project-img img-hove-effect">
                    <div className="xb-img">
                      {item.images.map((img, i) => (
                        <Link to={item.link} key={i}>
                          <img src={img} alt="service" />
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="xb-project-content">
                    <div className="xb-item--inner xb-border">
                      <h2 className="xb-item--title">{item.title}</h2>
                      <p className="xb-item--content clr-white">{item.content}</p>

                      <div className="xb-item--btn mt-40">
                        <Link className="thm-btn agency-btn" to={item.link}>
                          <span className="text">Explore</span>
                          <span className="arrow">
                            <span className="arrow-icon"><ArrowIcon /></span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </div>
          ))}

        </div>
      </div>
    </section>
    </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ProjectMegaPage;
